import { render, staticRenderFns } from "./AgreementTab.vue?vue&type=template&id=f150df8c"
import script from "./AgreementTab.vue?vue&type=script&lang=js"
export * from "./AgreementTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports